window.addEventListener("DOMContentLoaded", function () {
  $(".youtube, .popup-vimeo, .popup-gmaps").magnificPopup?.({
    type: "iframe",
    iframe: {
      markup:
        '<div class="mfp-iframe-scaler">' +
        '<div class="mfp-close"></div>' +
        '<iframe class="mfp-iframe" frameborder="0" allow="autoplay"></iframe>' +
        "</div>",
      patterns: {
        youtube: {
          index: "youtube.com/",
          id: "v=",
          src: "https://www.youtube.com/embed/%id%?autoplay=1"
        }
      }
    }
  });
});

document.querySelector(".addons_icon_footer a")?.addEventListener("click", function () {
  var iframe = document.getElementById("chat-button");
  var iframeDocument = iframe.contentDocument || iframe.contentWindow.document;
  var button = iframeDocument.querySelector("#gorgias-chat-messenger-button");
  if (button) {
    button.click();
  }
});
